<div
  *ngIf="state !== PpState.LOADING_PPS && state !== PpState.NO_COMPANY_NO_PORTFOLIO && state !== PpState.NO_PERIOD"
  class="flex flex-col gap-[0.625rem]">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row justify-start items-center h-[3rem] gap-[0.625rem]">
      <span class="font-2 bold600">Portfolio</span>
      <app-tabs-with-counter
        *ngIf="state !== PpState.COMPANY_WITH_NO_PORTFOLIO"
        data-qa="pp-tabs"
        [type]="TabType.Grey"
        [initialTabIndex]="tabs.selected"
        [tabNamesRaw]="tabs.all"
        (selectedTabEmitter)="switchTab($event)">
      </app-tabs-with-counter>
    </div>
    <div class="flex flex-row justify-center items-center gap-x-[0.5rem]">
      <app-button
        data-qa="comparison-button"
        [type]="'grey-accent'"
        [size]="'small'"
        [iconName]="'calendar-lists.svg'"
        (buttonClick)="switchTab(PP_TABS.COMPARISON)">
        Compare periods
      </app-button>
      <app-button
        *ngIf="isAdmin"
        data-qa="add-company-button"
        [type]="'grey-accent'"
        [size]="'small'"
        [iconName]="'plus.svg'"
        [disabled]="selected.fp?.blocked"
        [buttonTooltip]="{showCondition: selected.fp?.blocked, text: 'Period is locked'}"
        (buttonClick)="addCompany()">
        Company
      </app-button>
    </div>
  </div>
  <div>
    <router-outlet></router-outlet>
  </div>
</div>

<app-modal-choose-period
  *ngIf="state === PpState.NO_PERIOD"
  @fadeInOut
  [isAdmin]="isAdmin"
  (isPeriodConfirmed)="addNewPeriod($event)"
  (openBulkUpload)="show.fpBulkUpload = true">
</app-modal-choose-period>

<section *ngIf="state === PpState.NO_COMPANY_NO_PORTFOLIO && selected.period" class="main">
  <app-modal-choose-company
    @fadeInOut
    class="green-scroll"
    [isAdmin]="isAdmin"
    [companies]="companiesInOrg"
    [isBlocked]="selected.fp?.blocked ?? false"
    (companySelected)="goToRounds($event)"
    (newCompany)="addCompany()">
  </app-modal-choose-company>
</section>

<app-modal-fp-bulk-upload-wrapper
  *ngIf="show.fpBulkUpload"
  (closeEmitter)="show.fpBulkUpload = false; updateAllFp()">
</app-modal-fp-bulk-upload-wrapper>

<app-modal-company-crud
  *ngIf="show.modalCreateCompany"
  (companyCommonEmitter)="closeCreateModalCompany($event)">
</app-modal-company-crud>
